// --- Core ---
import {map} from 'underscore';
// --- SaniQ ---
import {Chat, deserializeMessage} from "../../../models/Chat";
import * as MessagesConstants from '../constants';
import * as AppConstants from "../../app/constants";

interface ChatState {
  isAutomaticReadEnabled: boolean;
  isFetching: boolean;
  isBulkSending: boolean;
  messagesCount: number;
  model: Chat;
}

const initialState: ChatState = {
  isAutomaticReadEnabled: true,
  model: {
    messages: [],
    patient: {
      information: {}
    },
    unreadCount: 0
  },
  isFetching: false,
  isBulkSending: false,
  messagesCount: 0
};

export function chat(state = initialState, action): ChatState {
  switch (action.type) {
    case MessagesConstants.FETCH_CHAT_STARTED:
      return {...state, isFetching: true, model: initialState.model};
    case MessagesConstants.FETCH_CHAT_COMPLETED: {
      return {
        ...state,
        isFetching: false,
        model: action.chat,
        messagesCount: action.chat.messages.length
      };
    }

    case MessagesConstants.SEND_MESSAGE_COMPLETED: {
      return {
        ...state,
        model: {
          ...state.model,
          messages: [
            ...state.model.messages,
            action.message
          ]
        },
        messagesCount: state.messagesCount + 1
      };
    }
    case MessagesConstants.SEND_BULK_MESSAGE_STARTED:
      return {...state, isBulkSending: true};
    case MessagesConstants.SEND_BULK_MESSAGE_COMPLETED:
      return {...state, isBulkSending: false};
    case MessagesConstants.READ_MESSAGE_COMPLETED: {
      const patientId = action.message.authorId.toString();
      const currentPatientId = state.model.patient.id.toString();

      if (currentPatientId && patientId === currentPatientId) {
        const newModel = {...state.model};
        newModel.unreadCount += action.message.readAt ? -1 : 1;
        newModel.messages = map(newModel.messages, (existingMessage) => {
          if (existingMessage.id === action.message.id) {
            return action.message;
          } else {
            return existingMessage;
          }
        });

        return {...state, model: newModel, messagesCount: state.messagesCount + 1};
      } else {
        return state;
      }
    }
    case MessagesConstants.CHANGE_AUTOMATIC_READ:
      return {...state, isAutomaticReadEnabled: action.enabled};
    case AppConstants.RECEIVE_MESSAGE: {
      const newModel = {...state.model};
      const message = deserializeMessage(action.message.data);
      //FIXME(Keune): A system message does not have the patientId as authorId
      const patientId = message.authorId.toString();
      const currentPatientId = newModel.patient.id.toString();

      if (currentPatientId && patientId === currentPatientId) {
        //FIXME(Keune): Put in the right place (sorted by created at)
        newModel.messages = newModel.messages.concat(message);
        newModel.unreadCount += 1;
        return {...state, model: newModel, messagesCount: state.messagesCount + 1};
      } else {
        return state;
      }
    }
    default:
      return state;
  }
}
